<template>
  <div>
    <div class="w-100 d-inline-block 
    position-relative">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 mt-xl-0 mt-2 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block appointment-demo-image">
              <div class="w-100 d-inline-block position-relative">
               <img class="position-relative w-100" v-lazy="require('@/assets/images/pet-grooming-equipment-pet-grooming-franchise-pet-grooming-prices.webp')" alt="pet grooming equipment, pet grooming franchise, pet grooming prices">
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 mt-xl-5 mt-4 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block confirmation-text">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">01</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Book an Appointment
                </span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                Your pet's grooming appointment is only with a few clicks away. Select the time windows that work best for your pet’s grooming requirements. We provide various scheduling choices as well you may book a grooming appointment on selected days.
              </p>
            </div>
            <div class="w-100 d-inline-block confirmation-text margin-top-3">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">02</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Booking Confirmation
                </span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                When appointment is confirmed, you will receive prompt confirmation via email or text, such as the date, time, services selected, and groomer designated for your appointment.You can simply modify or cancel the appointment if needed, with reminders sent as the appointment date arrives.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block position-relative padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 margin-xl-top-five col-sm-6 col-md-6 col-lg-6 order-xl-1 order-2">
            <div class="w-100 d-inline-block confirmation-text">
              <p class="w-100 d-inline-block mb-0 mt-xl-0 mt-3 mt-md-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">03</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Pet Groomer Appearance 
                </span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                Our trained pet groomer will arrive on time at your location, fully prepared with pet safe grooming equipment and supplies. We ensure a smooth experience for both you and your pet; you’ll be notified when the groomer is on their way, so you can be prepared.
              </p>
            </div>
            <div class="w-100 d-inline-block confirmation-text margin-top-3">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">04</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">
                  Meeting Discussion
                </span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                The groomer will hold a brief consultation to discuss your pet's grooming requirements to let you satisfy. Here you can talk about any issues or preferences you have about your pet's care, such as haircut styles or skin sensitivities. Our goal is to deliver a mobile grooming service that leaves your pet appearing and feeling amazing.
              </p>
            </div>
          </div>
          <div class="col-xl-6 col-12 mt-xl-0 mt-4 col-sm-6 col-md-6 col-lg-6 order-xl-2 order-1">
            <div class="w-100 d-inline-block pets-transport-image">
              <img class="d-xl-none d-block rounded-4 w-100" v-lazy="require('@/assets/images/pets-transport-image.webp')" alt="picture">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block position-relative padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block work-pets-groom-image">
              <img class="d-xl-none d-block rounded-4 w-100" v-lazy="require('@/assets/images/work-pets-groom-image.webp')" alt="picture">
            </div>
          </div>
          <div class="col-xl-6 col-12 margin-xl-top-5 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block confirmation-text">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">05</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Grooming Time.
                </span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                During the grooming procedure, your pet will be treated with attention to detail.Our groomers conduct everything with full attention. We focus your pet's comfort, making sure they have a happy and joyful experience. Our varieties of mobile grooming services make sure your pet stays tidy, fresh, and clean.
              </p>
            </div>
            <div class="w-100 d-inline-block confirmation-text margin-top-3">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">06</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Client Interaction
                </span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                We believe in keeping you updated on the grooming process. If you have any queries or want to know how things are going, our staff will keep you informed.You can also interact directly with the groomer to verify that your requirements are satisfied. We ensure straightforward and transparent communication in order to guarantee your happiness.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block position-relative padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 margin-xl-top-5 mt-md-2 col-sm-6 col-md-6 col-lg-6 order-xl-1 order-2">
            <div class="w-100 d-inline-block confirmation-text">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">07</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Payment</span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                After your pet's grooming session, you can easily make a payment with any of the methods that suit you the best, either online, card or cash.We have made the payment procedure as simple as possible. You will receive detailed receipts and may see your payment history through your online account.
              </p>
            </div>
            <div class="w-100 d-inline-block confirmation-text margin-top-3">
              <p class="w-100 d-inline-block mb-0">
                <span class="half-black family-grand-stander text-full-32 text-xs-size-16">08</span>
                <span class="border-right-before half-black position-relative"></span>
                <span class="half-black filson-black-family text-full-20 margin-left-4 text-xs-size-15">Keeping up</span>
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-3 text-full-13">
                Following each session, we offer you with customize suggestions on the guidelines to groom your pet in between sessions. This might include brushing techniques and suggested grooming products, and guidance on how to keep your pet's hair, skin, and nails in good shape of specific breed. We will also guide you on when yours pet need next grooming session.
              </p>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6 order-xl-2 order-1">
            <div class="w-100 d-inline-block dog-love-image">
              <img class="d-xl-none d-block rounded-4 w-100" v-lazy="require('@/assets/images/dog-love-image.webp')" alt="picture">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 margin-xl-top-5 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block">
              <p class="mb-0 text-size-14 nav-color family-filson-bold text-uppercase text-full-14">
                Reach out to Dubai
              </p>
              <h2 class="text-black fw-bold family-grand-stander w-70 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2 text-full-24 text-size-20">
                Book an appointment with Dubai Pets Groomer
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                Dubai pet groomers are trustworthy and hardworking in terms of providing outstanding pet grooming services and exclusive customer care with great professionalism. Our expert team is there to provide you best services and practices which will not only make your furry friend well-groomed but also make it happier from heart and mind. So why are you waiting for? Get in touch with us now to schedule an appointment for your furry friend. Let the magic happen.
              </p>
              <p class="mb-0 text-size-14 text-black family-inter-light margin-top-2 text-full-13">
                To get more insights on scheduling an appointment, just pay a visit to our website, go to the appointment booking section and there you have your dog grooming appointment at one touch on a screen!
              </p>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-60 d-inline-block ms-xl-5 margin-top-4 w-xs-100 w-md-100">
              <img class="w-100" v-lazy="require('@/assets/images/grooming-at-home-grooming-for-all-pets-professional-grooming-team.svg')" alt="grooming at home, grooming for all pets, professional grooming team">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    padding-bottom-4">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-xl-6 col-12 order-xl-1 order-2 mt-xl-0 mt-4 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block pets-collapse margin-bottom-2 bg-introduction">
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                @click="toggleCollapse"
              >
                <span class="float-start margin-right-2 nav-color">
                  <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </span>
                <span class="float-start w-92 text-full-14 text-size-14">
                How can I schedule a grooming appointment?
              </span>
              </a>
              <div :class="['collapse', { show: isOpen }]" id="collapseExample">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    You can easily schedule an appointment! All you need to do is click on our booking tab and select your suitable time and date, pick out the services from the options, and add it to your cart. Or you can contact us through our email and phone number 
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-2 bg-introduction">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
                <span class="float-start margin-right-2 nav-color">
                  <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </span>
                <span class="float-start w-92 text-full-14 text-size-14">
                Are your groomers professionally trained?
              </span>
              </a>
              <div class="collapse" id="collapseExample2">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Yes, all of our groomers are highly trained and experienced in handling pets of all breeds and kind. They’re skilled in gentle grooming techniques and ensure to provide a safe and comfortable experience for your pet.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-2 bg-introduction">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
                <span class="float-start margin-right-2 nav-color">
                  <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </span>
                <span class="float-start w-92 text-full-14 text-size-14">
                How long does a grooming session last?
              </span>
              </a>
              <div class="collapse" id="collapseExample3">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    The grooming session depends on your pet’s pet's requirements and the services. It typically lasts anywhere from 30 minutes to 2 hours.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-2 bg-introduction">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
                <span class="float-start margin-right-2 nav-color">
                  <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </span>
                <span class="float-start w-92 text-full-14 text-size-14">
                Do grooming sessions require our presence as well?
              </span>
              </a>
              <div class="collapse" id="collapseExample4">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13 text-xs-size-12">
                    We recommend your presence for a first meeting with the groomer when using our mobile grooming services. 
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-2 bg-introduction">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
                <span class="float-start margin-right-2 nav-color">
                  <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </span>
                <span class="float-start w-92 text-full-14 text-size-14">
                Can I cancel or postpone my appointment in case of an emergency?
              </span>
              </a>
              <div class="collapse" id="collapseExample5">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Yes, you can cancel or reschedule an appointment, please contact us using the information provided when you booked us. Please notify at least 4 to 6 hours before.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-2 bg-introduction">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
                <span class="float-start margin-right-2 nav-color">
                  <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                </span>
                <span class="float-start w-92 text-full-14 text-size-14">
                Is grooming safe for my pet?
              </span>
              </a>
              <div class="collapse" id="collapseExample6">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Absolutely! Our groomers make sure to let your pet feel happy, and safe throughout the grooming session. We use pet-friendly, mild, and gentle products to ensure your pet’s health.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-12 order-xl-2 order-1 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold filson-black-family text-full-28 w-80 w-xs-100 w-sm-100 w-md-100 margin-bottom-2 text-xs-size-20">
                What makes us different?
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                We will never let you compromise on two things. First is quality products, we use top-class products. From shampoo to conditioners, we don’t use anything less than original products. Another thing is that we give priority to your convenience. We provide our booking service at your convenience. You can book our service online or visit us. We love to make your pet's grooming process easy.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <p class="margin-bottom-1 text-black text-size-13 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                   Skilled groomers.
                </span>
              </p>
              <p class="margin-bottom-1 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 float-start margin-top-1" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                  24/7 customer support
              </span>
              </p>
              <p class="margin-bottom-1 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                   High-quality product
               </span>
              </p>
              <p class="margin-bottom-1 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                  Pet-friendly environment
                </span>
              </p>
              <p class="margin-bottom-1 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                  Mobile grooming services
               </span>
              </p>
              <p class="margin-bottom-1 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                     Free consultation
                </span>
              </p>
              <p class="margin-bottom-1 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true">
                </i>
                <span class="float-start w-92 text-full-13 text-size-14">
                  Highly affordable
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
        <li class="float-start margin-right-2">
          <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
            <i class="fa fa-home nav-color" aria-hidden="true"></i>
            Home  /
          </a>
        </li>
        <li class="float-start">
          <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
            Services
          </a>
        </li>
      </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "schduleAppointmentComponent",
    data() {
      return {
        isOpen: true,
      };
    },
    computed: {
      iconClass() {
        return this.isOpen ? "fa fa-check-circle-o text-green" : "fa fa-check-circle-o text-black";
      },
    },
    methods: {
      toggleCollapse() {
        this.isOpen = !this.isOpen;
      },
    },
  };
</script>


